import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifInput,
  MotifIcon,
  MotifTheme,
} from "@ey-xd/motif-react";
import "./GenerateKeyModal.scss";
import checkedCircle from "../../../assets/images/checked_circle.svg";
import { MotifToast } from "@ey-xd/motif-react";
import { maskSkuKey } from "../../../utils/common";
import { useEffect, useRef } from "react";
import { IconoirCopy, IconoirEyeClosed } from "@ey-xd/motif-icon";
import { IconoirEye } from "@ey-xd/motif-icon";

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
  selectedSku: string;
  keyVal: string;
  showFull: boolean;
  setShowFull: (showFull: boolean) => void;
  showToast: boolean;
  setShowToast: (showToast: boolean) => void;
  hasApiKey: boolean;
  selectedSkuName: string;
};

export default function GenerateKeyModal({
  show,
  setShow,
  selectedSku,
  keyVal,
  showFull,
  setShowFull,
  showToast,
  setShowToast,
  hasApiKey,
  selectedSkuName,
}: Readonly<Props>) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(keyVal);
    setShowToast(true);
  };

  return (
    <>
      <MotifTheme variant={"light"}></MotifTheme>
      <MotifModal
        show={show}
        size="default"
        className="key-modal"
        onClose={() => setShow(false)}
      >
        <MotifModalHeader
          className={`key-modal-header ${hasApiKey ? "view" : ""}  `}
        >
          {hasApiKey ? (
            <h4>API Key</h4>
          ) : (
            <img
              src={checkedCircle}
              alt="Success"
              className="checked-circle-icon"
            />
          )}
        </MotifModalHeader>

        <MotifModalBody 
          className="key-modal-body"
          style={{
            marginTop: hasApiKey ? '0px' : '-28px' 
          }}
        >
          <div>
            {hasApiKey ? (
              <p className="key-modal-body-text">
                Your API Key for {selectedSkuName} is{" "}
                <span>now available.</span> Please make note of this key and
                make it secure.
              </p>
            ) : (
              <>
                <p className="key-modal-header-text">API Key Generated!</p>
                <p className="key-modal-body-text">
                  Your API Key for{" "}
                  <span>
                    "{selectedSkuName}-{selectedSku}"
                  </span>{" "}
                  is now available. Please make note of this key and make it
                  secure.
                </p>
              </>
            )}

            <div className="key-modal-body-section">
              <div className="key-modal-input-container">
                <MotifInput
                  ref={inputRef}
                  type="text"
                  readOnly
                  hideClearButton
                  value={maskSkuKey(keyVal, showFull)}
                  className="key-modal-input"
                ></MotifInput>

                {!hasApiKey && (
                  <MotifButton
                    variant="secondary"
                    onClick={() => setShowFull(true)}
                  >
                    {showFull ? (
                      <MotifIcon iconFunction={IconoirEye} />
                    ) : (
                      <MotifIcon iconFunction={IconoirEyeClosed} />
                    )}
                  </MotifButton>
                )}
              </div>

              <MotifButton
                className="key-modal-btn"
                type="button"
                variant={!hasApiKey ? "secondary" : "primary"}
                onClick={handleCopy}
              >
                <MotifIcon iconFunction={IconoirCopy} />
                Copy
              </MotifButton>
            </div>

            {showToast && (
              <MotifToast variant="success" className="key-modal-toast">
                <div
                  slot="toast-supporting-text"
                  className="key-modal-toast-message"
                >
                  Link copied successfully.
                </div>
              </MotifToast>
            )}
          </div>
        </MotifModalBody>
        <MotifModalFooter>
          <MotifButton
            type="button"
            variant="secondary"
            onClick={() => setShow(false)}
          >
            Cancel
          </MotifButton>
          <MotifButton
            variant="primary"
            type="button"
            onClick={() => {
              setShow(false);
            }}
          >
            Confirm
          </MotifButton>
        </MotifModalFooter>
      </MotifModal>
    </>
  );
}
